import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class ProjectMonthlyPrintReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salaryData: props.salaries.map((salary) => ({
        ...salary,
        deduction: "",
        net_salary: salary.total_salary,
      })),
    };
  }

  handleDeductionChange = (event, index) => {
    const value = event.target.value; // Get the input value from the event

    this.setState((prevState) => {
      const updatedSalaries = prevState.salaryData.map((item, i) => {
        if (i === index) {
          const deduction = value; // Keep raw input value as string to allow typing
          const netSalary = item.total_salary - parseFloat(deduction || 0);

          return {
            ...item,
            deduction: deduction, // Store the raw input value
            net_salary: netSalary >= 0 ? netSalary : 0, // Ensure net salary doesn't go negative
          };
        }
        return item;
      });
      return { salaryData: updatedSalaries };
    });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.salaries !== prevState.salaries) {
      return {
        salaryData: nextProps.salaries.map((salary) => ({
          ...salary,
          //deduction: "", // Reset to empty string
          //net_salary: salary.total_salary,
        })),
      };
    }
    return null;
  }

  render() {
    const { salaries, month, project, grand, grandHours } = this.props;
    const { salaryData } = this.state;

    return (
      <React.Fragment>
        <Table celled fixed singleLine>
          <Table.Body style={{ fontSize: "10px" }}>
            <Table.Row>
              <Table.Cell style={{ margin: "0px", padding: "2px" }}>
                {project != "" ? (
                  <Table celled fixed singleLine>
                    <Table.Row>
                      <Table.Cell
                        colSpan="35"
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                          fontSize: "14px",
                        }}
                      >
                        {project}
                      </Table.Cell>
                    </Table.Row>
                  </Table>
                ) : (
                  ""
                )}

                <Table celled fixed singleLine>
                  <Table.Row>
                    <Table.Cell
                      colSpan="35"
                      style={{
                        padding: "4px",
                        margin: 0,
                        textAlign: "center",
                        backgroundColor: "#00A6E7",
                        color: "#ffffff",
                        fontSize: "14px",
                      }}
                    >
                      {month}
                    </Table.Cell>
                  </Table.Row>
                </Table>

                <Table celled fixed singleLine>
                  <Table.Body style={{ fontSize: "10px" }}>
                    <Table.Row>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        Sr.
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          whiteSpace: "pre-line",
                          width: "200px",
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        Name
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          whiteSpace: "pre-line",
                          width: "40px",
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        Salary
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        01
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        02
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        03
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        04
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        05
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        06
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        07
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        08
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        09
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        10
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        11
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        12
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        13
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        14
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        15
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        16
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        17
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        18
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        19
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        20
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        21
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        22
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        23
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        24
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        25
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        26
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        27
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        28
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        29
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        30
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        31
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          whiteSpace: "pre-line",
                          width: "40px",
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        T/hrs
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          whiteSpace: "pre-line",
                          width: "60px",
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        T/Salary
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          whiteSpace: "pre-line",
                          width: "60px",
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        Adv
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          padding: "4px",
                          margin: 0,
                          whiteSpace: "pre-line",
                          width: "60px",
                          textAlign: "center",
                          backgroundColor: "#00A6E7",
                          color: "#ffffff",
                        }}
                      >
                        N.Bal
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <Table celled fixed singleLine>
                  <Table.Body>
                    {salaryData.map((salary, index) => (
                      <Table.Row key={index}>
                        <Table.Cell style={{ margin: "0px", padding: "2px" }}>
                          <Table celled fixed singleLine>
                            <Table.Body style={{ fontSize: "10px" }}>
                              <Table.Row>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    whiteSpace: "pre-line",
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["sr"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    whiteSpace: "pre-line",
                                    width: "200px",
                                    textAlign: "left",
                                  }}
                                >
                                  {salary["name"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    whiteSpace: "pre-line",
                                    width: "40px",
                                    textAlign: "left",
                                  }}
                                >
                                  {salary["salary"]}
                                </Table.Cell>

                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["01"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["2"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["3"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["4"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["5"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["6"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["7"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["8"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["9"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["10"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["11"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["12"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["13"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["14"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["15"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["16"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["17"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["18"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["19"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["20"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["21"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["22"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["23"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["24"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["25"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["26"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["27"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["28"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["29"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["30"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    textAlign: "center",
                                  }}
                                >
                                  {salary["31"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    whiteSpace: "pre-line",
                                    width: "40px",
                                  }}
                                >
                                  {salary["thours"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    whiteSpace: "pre-line",
                                    width: "60px",
                                  }}
                                >
                                  {salary["total_salary"]}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    whiteSpace: "pre-line",
                                    width: "60px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    class="input"
                                    maxLength={4}
                                    value={salary.deduction}
                                    style={{
                                      height: "16px",
                                      width: "45px",
                                      border: 0,
                                    }}
                                    onChange={(e) =>
                                      this.handleDeductionChange(e, index)
                                    }
                                  />
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "4px",
                                    margin: 0,
                                    whiteSpace: "pre-line",
                                    width: "47px",
                                  }}
                                >
                                  {salary.net_salary}
                                </Table.Cell>
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>

                <Table celled fixed singleLine style={{ marginBottom: "10px" }}>
                  <Table.Body style={{ fontSize: "10px" }}>
                    <Table.Row>
                      <Table.Cell
                        colSpan="34"
                        style={{ textAlign: "right" }}
                      ></Table.Cell>
                      <Table.Cell style={{ textAlign: "right", width: "60px" }}>
                        {grandHours}
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "right", width: "60px" }}>
                        {grand}
                      </Table.Cell>
                      <Table.Cell
                        style={{ textAlign: "right", width: "60px" }}
                      ></Table.Cell>
                      <Table.Cell
                        style={{ textAlign: "right", width: "60px" }}
                      ></Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </React.Fragment>
    );
  }
}
export default ProjectMonthlyPrintReport;
